var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransfertCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 22.9167V18.75M8.33203 20.8333V18.75M16.6654 20.8333V18.75",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5221 17.7085C21.4096 17.5413 22.0791 17.262 22.6172 16.7961C23.9596 15.6337 23.9596 13.7628 23.9596 10.021C23.9596 6.27923 23.9596 4.40834 22.6172 3.24592C21.2748 2.0835 19.1141 2.0835 14.793 2.0835H10.2096C5.88842 2.0835 3.72783 2.0835 2.38539 3.24592C1.04297 4.40834 1.04297 6.27923 1.04297 10.021C1.04297 13.7628 1.04297 15.6337 2.38539 16.7961C2.92349 17.262 3.59302 17.5413 4.48047 17.7085",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2718 10.4165H19.2617",
    stroke: "#AEB6FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74057 10.4165H5.73047",
    stroke: "#AEB6FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 13.0128C15.1267 13.9539 14.22 14.5833 13.1842 14.5833C11.6115 14.5833 10.3365 13.1324 10.3365 11.3426V9.49073C10.3365 7.70093 11.6115 6.25 13.1842 6.25C14.22 6.25 15.1267 6.87944 15.625 7.82056M9.375 10.4167H13.4616",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfertCash);
export default __webpack_public_path__ + "static/media/iconTransfertCash.13d859e9d089e4c056b5352671a0f068.svg";
export { ForwardRef as ReactComponent };